import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "pages.devonlytestpage" */ './DevOnlyTestPage.component'
    ),
);
